import { Reducer } from 'redux';

import enhanceUser from '../enhanceUser';
import { SET_USER, SetUserAction, UserState } from './types';

const defaultState: UserState = {
  canImpersonate: false,
  canViewAllPatientTracking: false,
  canViewInternalDocuments: false,
  canViewNewDocuments: false,
  canViewPatientTracking: false,
  canAccessPatientWorkspace: false,
  canViewSiteDocuments: false,
  canWriteDocuments: false,
  canWritePatientTracking: false,
  canWritePatientTrackingExternal: false,
  canViewCarePathways: false,
  effectiveRoles: [],
  features: [],
  featuresLoaded: false,
  loaded: false,
  notificationPreferences: [],
  unprefixedRoles: [],
  user: null,
};

const reducer: Reducer<UserState, SetUserAction> = (
  state: UserState = { ...enhanceUser(defaultState), ...defaultState },
  action: SetUserAction,
): UserState => {
  switch (action.type) {
    case SET_USER: {
      const { user } = action;

      // Remove any environment prefixes.
      const prefixedRoles = user ? user.sundial_roles || [] : [];
      const unprefixedRoles = prefixedRoles.map((r) => r.split(':')[1]);

      return enhanceUser({
        user,
        loaded: true,
        unprefixedRoles,
      });
    }
    default:
      return state;
  }
};

export default reducer;
